import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { useProcessClaimsMutation } from '../../redux/services/processClaimsApi';

const ProcessClaimsScreen = props => {
  const [process, response] = useProcessClaimsMutation();
  const onClick = async e => process();
  return (
      <Stack alignItems='center' padding={4}>
        {
          response?.error && 
          <Alert severity='error'>
            Error processing claims
          </Alert>
        }
        {
          response?.data && 
          <Alert severity='success'>
            {response?.data?.data?.process_claims}
          </Alert>
        }
        <Button
          color='error'
          variant='contained'
          onClick={onClick}
        >
          Process Claims
        </Button>
      </Stack>
  );
};

export default ProcessClaimsScreen;